import type { Degree } from '@/features/execute-calculation-set/overmind/calculation/domain/Degree';

import type { Percent } from '../../../../../domain/Percent';
import type { Voltage } from '../../../../../domain/Voltage';
import type { AttentionStatusType } from '../../../../AttentionStatus';
import type { ForMessaging } from '../../../../AttentionStatusRepository';
import type { EvaluatedResult } from '../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../RulesProvider';
import type { ForBusbarEvaluation } from '../../../gridElements/busbar/forBusbarEvaluation';
import { VoltageCosinePhiEvaluation } from './propertiesEvaluation/VoltageCosinePhiEvaluation';
import { VoltageDiffNominalEvaluation } from './propertiesEvaluation/VoltageDiffNominalEvaluation';
import { VoltageDiffTransformerEndEvaluation } from './propertiesEvaluation/VoltageDiffTransformerEndEvaluation';
import { VoltageDiffTransformerEndPercentEvaluation } from './propertiesEvaluation/VoltageDiffTransformerEndPercentEvaluation';
import { VoltageEvaluation } from './propertiesEvaluation/VoltageEvaluation';

export class BusbarEvaluationEngine implements ForBusbarEvaluation {
  constructor(private readonly rulesProvider: ForRuleProviding) {}

  public evaluateVoltageDiffTransformerEndPercent(
    voltageDiffTransformerEndPercent: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Percent> {
    const evaluation = new VoltageDiffTransformerEndPercentEvaluation(
      this.rulesProvider
    ).evaluate(voltageDiffTransformerEndPercent);

    messenger.send(
      evaluation.status,
      this.evaluateVoltageDiffTransformerEndPercent.name
    );
    return evaluation.toEvaluatedResult();
  }

  public evaluateVoltage(
    voltage: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Voltage> {
    const evaluation = new VoltageEvaluation(this.rulesProvider).evaluate(
      voltage
    );
    messenger.send(evaluation.status, this.evaluateVoltage.name);
    return evaluation.toEvaluatedResult();
  }

  evaluateVoltageCosinePhi(
    voltageCosinePhi: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Degree> {
    const evaluation = new VoltageCosinePhiEvaluation(
      this.rulesProvider
    ).evaluate(voltageCosinePhi);
    messenger.send(evaluation.status, this.evaluateVoltageCosinePhi.name);
    return evaluation.toEvaluatedResult();
  }

  evaluateVoltageDiffNominal(
    voltageDiffNominal: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Voltage> {
    const evaluation = new VoltageDiffNominalEvaluation(
      this.rulesProvider
    ).evaluate(voltageDiffNominal);
    messenger.send(evaluation.status, this.evaluateVoltageDiffNominal.name);
    return evaluation.toEvaluatedResult();
  }

  evaluateVoltageDiffTransformerEnd(
    voltageDiffNominal: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Voltage> {
    const evaluation = new VoltageDiffTransformerEndEvaluation(
      this.rulesProvider
    ).evaluate(voltageDiffNominal);
    messenger.send(
      evaluation.status,
      this.evaluateVoltageDiffTransformerEnd.name
    );
    return evaluation.toEvaluatedResult();
  }
}
